module.exports = __webpack_public_path__ + "static/media/email.db66e610.svg";